// ---------------------------------------------------------
// Datei: GoogleSignInButton.tsx
// Zweck: Rendert nur den Google-Button über die bereits zentral
//        initialisierte Google Identity Services Instanz.
// Kontext: Initialisierungszustand kommt vom AuthProvider.
// Stand: 2026-09-10
// ---------------------------------------------------------

import React, { useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getGoogleIdentity } from '../../interfaces/google-identity';

const GoogleSignInButton: React.FC = () => {
  const { isGoogleReady } = useAuth();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    const googleIdentity = getGoogleIdentity();
    if (!isGoogleReady || !container || !googleIdentity) return;

    googleIdentity.renderButton(container, {
      type: 'standard',
      theme: 'outline',
      text: 'signin_with',
      shape: 'rectangular',
      width: Math.min(320, container.clientWidth),
    });
    return () => container.replaceChildren();
  }, [isGoogleReady]);

  return <div ref={containerRef} className="h-10 w-full max-w-[320px]" />;
};

export default GoogleSignInButton;
